export class ReportTaskDto {
  username: string;
  teamLeaderCount: number;
  operativeUnitCode: number;
  taskTypeName: number;
  taskCount: number;
}
